import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

import axios from "axios";



const initialState = {
    entities: [],
    status: 'idle', // idle loading success fail  
    error: null
}
//GetReport/{AuthToken}/	
const PLATFORM = '../../WsWebServiceReporting/'
const WELLSUITE = '../../WsWebServiceWellSuite/';

export const fetchUIReport = createAsyncThunk('uireports/get', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(WELLSUITE + "GetViewInstance/" + incomingVariable.AuthToken + "/" + incomingVariable.VIGuid+'/')
        const data = await response.data

        return data

    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const uireportSlice = createSlice({
    name: 'uireports',
    initialState,
    reducers: {
        uireportClear(state, action) {
            state.entities = initialState.entities
            state.status = 'idle'
            state.error = null
        },
        uireportModify(state, action) {
            const uireportData = action.payload
            state.entities[uireportData.Key] = uireportData.Value
        },

        uireportDelete(state, action) {
            const uireportData = action.payload
            delete state.entities[uireportData.Key]
        },
        uireportHydrate(state, action) {
            const uireportData = action.payload
            state.entities = uireportData
            state.status = 'success'
        },
        uireportResetStatus(state, action){
            state.status='idle'
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchUIReport.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchUIReport.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success === true) {
                    state.error = null
                    state.status = 'success'
                    const loadedData = action.payload.Info[0].ViewInstanceData[0].ReportViewInstance.ReportPage[0].ReportFrame
                    state.entities = loadedData
                } else {
                    state.status = 'failed'
                    state.error = action.payload.Status[0]
                }
            })
            .addCase(fetchUIReport.rejected, (state, action) => {
                state.error = action.error.message

            })
    }

})

export const { uireportClear, uireportModify, uireportDelete, uireportHydrate, uireportResetStatus } = uireportSlice.actions

export default uireportSlice.reducer

export const selectUIReportEntities = (state) => state.uireports.entities

export const selectUIReports = createSelector(selectUIReportEntities, (entities) =>
    Object.values(entities)
)

export const selectUIReportById = (state, UIReportId) => {
    return selectUIReportEntities(state)[UIReportId]
}

